<template>

    <section>

        <!-- 最近のお知らせ表示なし ここから -->

        <div class="news_component">

            <div class="md_common-bl _padding-add">
                <div class="inner">

                    <div class="md_inner-small">

                        <!-- PostTitle -->
                        <div class="post-title">
                            <time>2021/9/1</time>
                            <h2><span>新プラン登場！Premiumプランでトラッキング機能追加可能です！</span></h2>
                        </div>
                        <!-- PostBody -->
                        <div class="post-body">
                            <p>いつもAuma.をご利用いただきありがとうございます。より高度なトラッキングを可能にするPremiumプラン なら、ショップの行動をトラッキングしながら、御社の販路拡大に貢献致します。さあ、今すぐPremiumプランにアップグレードしませんか！</p>
                            <a href="">Premiumプランに申し込む</a>
                        </div>

                    </div><!-- /.md-inner-small -->

                </div>
            </div><!-- /.md_common-bl -->

            <!--btn-link-wrap-->
            <div class="btn_link-wrap">

                <!--LinkBtn-->
                <Link class="btn_link md_icon-text _white" :href="route('admin.brand.dm.list')">
                    <div class="inner">
                        <span><div class="icon"><SvgIconBack /></div>一覧へ戻る</span>
                    </div>
                </Link>

            </div><!--/.btn-link-wrap-->

        </div><!-- /.news_componentl -->

        <!-- 最近のお知らせ表示なし ここまで -->

    </section>

</template>


<script>
    import { Link } from '@inertiajs/inertia-vue3'

    //Svg
    import SvgIconLink from '@/components/EndUser/svg/SvgIconLink'
    import SvgIconBack from '@/components/EndUser/svg/SvgIconBack'

    export default {
        components: {
            "Link": Link,
            SvgIconLink,
            SvgIconBack
        },
    }
</script>
